<template>
  <template v-if="remaining">
    <div class="flex justify-center bg-vp-secondary-5 rounded-sm text-vp-base-900 text-xl font-bold px-2">
      <p v-if="isExpired">
        {{ $gettext('Time is up!') }}
      </p>
      <p v-else>
        <Accessible :description="$gettext('Time remaining:')" />
        {{ formattedRemaining }}
      </p>
    </div>
  </template>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, onUnmounted } from 'vue';
import { DateTime, Duration } from 'luxon';
import { Accessible } from '@vp/vue-components';

type Props = {
  targetTime: string;
};
const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'expired'): void;
}>();

const remaining = ref<Duration>();
let interval: ReturnType<typeof setInterval> | undefined;

onMounted(() => {
  interval = setInterval(updateRemaining, 1000);
});

onUnmounted(() => {
  clearInterval(interval);
});

const updateRemaining = () => {
  remaining.value = DateTime.now().until(DateTime.fromISO(props.targetTime)).toDuration(['minutes', 'seconds']);

  if (!remaining.value.isValid) {
    remaining.value = Duration.fromMillis(0);
    onExpired();
  }
};

const isExpired = computed(() => remaining?.value?.get('second') == 0);

const onExpired = () => {
  clearInterval(interval);
  emit('expired');
};

const formattedRemaining = computed(() => remaining.value?.toFormat('m:ss'));
</script>
